import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Calendar,
  MapPin,
  Microscope,
  Users,
  BookOpen,
  GraduationCap,
  ChevronRight,
  Info,
  Award,
  CheckCircle2,
  FileText,
  Clock,
  Globe,
  Gavel,
  TreePine,
  UserCheck,
  Menu,
  X,
} from "lucide-react";
import ramiro from "../img/investiga/ramiro.png";
import patricia from "../img/investiga/patricia.jpeg";
import xavier from "../img/investiga/xavier.jpg";
import julio from "../img/investiga/julio.jpeg";

const Informacion = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Scroll handler for navbar effects
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const simposios = [
    {
      title: "Derecho, Ciencia y Tecnologías Emergentes",
      icon: <Gavel className="w-8 h-8" />,
      desc: "Analiza la relación entre el derecho, la ciencia y las tecnologías emergentes, comprendiendo los desafíos en la regulación de innovaciones.",
    },
    {
      title: "Gobernanza, Territorio y Ciencias de la Vida",
      icon: <TreePine className="w-8 h-8" />,
      desc: "Explora la intersección entre gobernanza territorial, dinámicas socioambientales y ciencias de la vida frente al cambio climático.",
    },
    {
      title: "Ciencias Políticas, Democracia y Políticas Públicas",
      icon: <Globe className="w-8 h-8" />,
      desc: "Profundiza en procesos políticos y dinámicas democráticas para la construcción de sistemas inclusivos y resilientes.",
    },
    {
      title: "Ciencias Sociales y del Comportamiento",
      icon: <UserCheck className="w-8 h-8" />,
      desc: "Examina los procesos sociales y dinámicas del comportamiento humano en contextos contemporáneos y Derechos Humanos.",
    },

 
  ];

  const ponentes = [
    {
      name: "Julio César Mateus",
      type: "Internacional",
      role: "Doctor en Comunicación (Cum Laude)",
      institution: "Universidad de Lima",
      bio: "Especialista en culturas digitales y educación con amplia producción académica internacional.",
      img: julio,
    },
    {
      name: "Xavier León Vega",
      type: "Nacional",
      role: "Miembro de GRAIN América Latina",
      institution: "Universidad Amawtay Wasi",
      bio: "Experto en soberanía alimentaria, extractivismo y desarrollo rural.",
      img: xavier,
    },
    {
      name: "Ramiro Ávila",
      type: "Nacional",
      role: "Doctor en Sociología Jurídica",
      institution: "Universidad Andina Simón Bolívar",
      bio: "Magíster por Columbia Law School y Human Rights Fellow.",
      img: ramiro,
    },
    {
      name: "Patricia Sotomayor",
      type: "Nacional",
      role: "Doctora en Ciencia Política",
      institution: "USFQ / AECIP",
      bio: "Presidenta de la Asociación Ecuatoriana de Ciencia Política.",
      img: patricia,
    },
  ];

  const estadisticas = [
    { value: "720", label: "Ponencias orales", sub: "Aportes al conocimiento" },
    {
      value: "380",
      label: "Pósteres científicos",
      sub: "Excelencia investigativa",
    },
    { value: "300", label: "Proyectos inst.", sub: "Impacto territorial" },
    { value: "90", label: "Aliados", sub: "Ecosistema de colaboración" },
  ];

  const comite = [
      {
      name: "Gabriela Moreira Aguirre ",
      dept: "Decana de la Facultad de Ciencias Jurídicas y Políticas  ",
      url: "https://investigacion.utpl.edu.ec/dgmoreira ",
    },
     {
      name: "Enrique Luzuriaga Muñoz",
      dept: "Vicedecano de la Facultad de Ciencias Jurídicas y Políticas ",
      url: "https://investigacion.utpl.edu.ec/edluzuriaga",
    },
          {
      name: "Marlon Ramón Mendieta",
      dept: "Docente de la Facultad de Ciencias Económicas y Empresariales",
      url: "https://investigacion.utpl.edu.ec/mgramon ",
    },
      {
      name: "Paúl González Torres",
      dept: "Docente de la Facultad de Ciencias Sociales, Educación y Humanidades ",
      url: "https://investigacion.utpl.edu.ec/pfgonzalez",
    },
      {
      name: "Alexandra Moncayo",
      dept: "Docente de la Facultad de Ingenierías y Arquitectura ",
      url: "https://investigacion.utpl.edu.ec/admoncayo",
    },
      {
      name: "Víctor López Guerra",
      dept: "Docente de la Facultad de Ciencias del Comportamiento ",
      url: "https://investigacion.utpl.edu.ec/vmlopez5",
    },
    {
      name: "María Beatriz Eguiguren",
      dept: "Coordinadora del programa institucional Cultura de Paz, Justicia y Gobernanza para el bien común ",
      url: "https://investigacion.utpl.edu.ec/mbeguiguren",
    },
       {
      name: "Santiago Pérez Samaniego ",
      dept: "Coordinador de Cátedras Unesco UTPL  ",
      url: "https://investigacion.utpl.edu.ec/saperez1 ",
    },
    {
      name: "Juan Andrés Jaramillo ",
      dept: "Director de la Carrera de Derecho ",
      url: "https://investigacion.utpl.edu.ec/jajaramillo ",
    },
    {
      name: "María Gabriela Espinosa",
      dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/mgespinosa ",
    },
    {
      name: "Marcelo Cevallos Costa",     dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/macosta ",
    },
    {
      name: "Nicole Valarezo",
     dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/nlvalarezo1",
    },

    {
      name: "Luis Ordóñez Pineda",
       dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/loordonez",
    },
    {
      name: "Ana Karina Vera ",
        dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/akvera ",
    },
    {
      name: "Jorge Benítez Hurtado",
     dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/jabenitezxx",
    },
    {
      name: "Pablo Castillo Álvarez ",
          dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/pjcastillo2 ",
    },
    {
      name: "Maleny Reyes Conza",
          dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/mgreyes ",
    },
    {
      name: "Sandra Encarnación Ordoñez",
           dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/sjencarnacion ",
    },
 
  
   
    ,
    {
      name: "Carlos García Torres",
      dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas ",
      url: "https://investigacion.utpl.edu.ec/cegarcia ",
    },

  ];

  return (
    <div className="min-h-screen bg-white font-sans text-slate-800 overflow-x-hidden">
      {/* Hero Section */}
      <section
        id="inicio"
        className="relative overflow-hidden bg-[#002855] pt-40 pb-24 text-white"
      >
        {/* Animated Background Orbs */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <motion.div
            animate={{
              scale: [1, 1.2, 1],
              x: [0, 50, 0],
              y: [0, 30, 0],
            }}
            transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
            className="absolute top-0 left-0 w-[500px] h-[500px] bg-[#FFC72C]/10 rounded-full filter blur-[120px] -translate-x-1/2 -translate-y-1/2"
          />
          <motion.div
            animate={{
              scale: [1, 1.3, 1],
              x: [0, -40, 0],
              y: [0, -50, 0],
            }}
            transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
            className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-blue-400/10 rounded-full filter blur-[140px] translate-x-1/2 translate-y-1/2"
          />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className=" flex justify-center  text-center">
            <motion.div
              initial="hidden"
              animate="visible"
              variants={staggerContainer}
            >
              <motion.div
                variants={fadeInUp}
                className="inline-flex items-center space-x-2 bg-blue-900/50 border border-blue-700 rounded-full px-4 py-1.5 mb-8"
              >
                <Microscope className="w-4 h-4 text-[#FFC72C]" />
                <span className="text-xs font-bold tracking-wider uppercase">
                  14ª Edición | Divulgación e Innovación
                </span>
              </motion.div>
              <h2 className=" font-bold text-4xl text-[#FFC72C]">
                Investiga XIV
              </h2>

              <motion.h1
                variants={fadeInUp}
                className="text-3xl md:text-5xl font-black mb-8 leading-[1.1]"
              >
                Gobernanza, justicia y{" "}
                <span className="text-[#FFC72C]">cultura de paz</span>
              </motion.h1>

              <motion.p
                variants={fadeInUp}
                className="text-xl text-blue-100 mb-10  max-w-lg m-auto"
              >
                Impulsando el conocimiento frente a los desafíos contemporáneos
                para sociedades sostenibles.
              </motion.p>

              <motion.div
                variants={fadeInUp}
                className="flex flex-wrap justify-center gap-8 mb-12"
              >
                <div className="flex items-center space-x-3 group">
                  <div className="p-2 bg-blue-800 rounded-lg group-hover:bg-[#FFC72C] transition-colors">
                    <Calendar className="w-5 h-5 group-hover:text-[#002855]" />
                  </div>
                  <div>
                    <p className="text-[10px] text-blue-300 font-bold uppercase">
                      Cuándo
                    </p>
                    <p className="font-semibold">9 y 10 de junio de 2026</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3 group">
                  <div className="p-2 bg-blue-800 rounded-lg group-hover:bg-[#FFC72C] transition-colors">
                    <MapPin className="w-5 h-5 group-hover:text-[#002855]" />
                  </div>
                  <div>
                    <p className="text-[10px] text-blue-300 font-bold uppercase">
                      Dónde
                    </p>
                    <p className="font-semibold">Centro Convenciones UTPL</p>
                  </div>
                </div>
              </motion.div>

              <motion.div
                variants={fadeInUp}
                className="flex flex-wrap justify-center gap-4"
              >
                <motion.a
                  href="#participar"
                  whileHover={{
                    scale: 1.05,
                    boxShadow:
                      "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                  }}
                  whileTap={{ scale: 0.95 }}
                  className="bg-[#FFC72C] text-[#002855] px-10 py-5 rounded-2xl font-black text-lg shadow-xl hover:text-white"
                >
                  Participa ahora
                </motion.a>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Intro Quote */}
      <section className="py-24 bg-slate-50 overflow-hidden">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="max-w-5xl mx-auto px-4 text-center"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-sm font-black text-blue-600 tracking-[0.3em] uppercase mb-8">
              Acerca del evento
            </h2>
            <p className="text-xl md:text-2xl text-[#002855] leading-relaxed font-medium italic">
              En su décima cuarta edición, impulsa estratégicamente el
              conocimiento frente a los desafíos contemporáneos, posicionándose
              como uno de los principales encuentros de divulgación e innovación
              del país. Articula capacidades académicas, territoriales e
              institucionales para incidir en los desafíos de gobernanza,
              justicia y cohesión social, bajo el eje{" "}
              <b>
                {" "}
                “Gobernanza, Justicia y Cultura de Paz para sociedades
                sostenibles".
              </b>
            </p>
          </motion.div>
        </motion.div>
      </section>

      {/* Simposios */}
      <section
        id="simposios"
        className="py-32 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
      >
        <div className="flex flex-col md:flex-row justify-between items-end mb-20">
          <div className="max-w-2xl">
            <h2 className="text-sm font-black text-blue-600 tracking-widest uppercase mb-4">
              Simposios Temáticos
            </h2>
            <p className="text-3xl font-bold text-[#002855] leading-tight">
              Explora nuestras áreas de impacto científico
            </p>
          </div>
        </div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="grid md:grid-cols-1 lg:grid-cols-4 gap-8"
        >
          {simposios.map((item, idx) => (
            <motion.div
              key={idx}
              variants={fadeInUp}
              whileHover={{ y: -12 }}
              className="group bg-white p-10 rounded-[2rem] border border-slate-100 shadow-sm hover:shadow-2xl hover:border-[#FFC72C]/30 transition-all duration-300"
            >
              <div className="w-20 h-20 bg-blue-50 text-[#002855] rounded-3xl flex items-center justify-center mb-8 group-hover:bg-[#002855] group-hover:text-white transition-all duration-300">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold mb-5 text-[#002855] leading-snug">
                {item.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed mb-2 group-hover:text-slate-900 transition-colors">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </section>

      {/* Ponentes Section */}
      <section
        id="ponentes"
        className="py-32 bg-slate-900 text-white relative overflow-hidden"
      >
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern
                id="grid"
                width="40"
                height="40"
                patternUnits="userSpaceOnUse"
              >
                <path
                  d="M 40 0 L 0 0 0 40"
                  fill="none"
                  stroke="white"
                  strokeWidth="1"
                />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
          </svg>
        </div>

        <div className="max-w-7xl mx-auto  sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-24">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="text-5xl font-bold text-white mb-6"
            >
              Ponentes Magistrales
            </motion.h2>
            <p className="text-white max-w-2xl mx-auto text-lg">
              Reuniendo el liderazgo global en investigación para compartir
              visiones que transforman territorios.
            </p>
          </div>

          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="grid md:grid-cols-2 lg:grid-cols-4 gap-10"
          >
            {ponentes.map((p, idx) => (
              <motion.div
                key={idx}
                variants={fadeInUp}
                whileHover={{ y: -15 }}
                className="group bg-slate-800/50 backdrop-blur-md rounded-3xl overflow-hidden border border-white/5 hover:border-[#FFC72C]/40 transition-all"
              >
                <div className="h-72 overflow-hidden relative">
                  <img
                    src={p.img}
                    alt={p.name}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all duration-700"
                  />
                  <div className="absolute top-6 left-6">
                    <span
                      className={`text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-widest ${p.type === "Internacional" ? "bg-[#FFC72C] text-[#002855]" : "bg-blue-600 text-white"}`}
                    >
                      {p.type}
                    </span>
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-black mb-2 group-hover:text-[#FFC72C] transition-colors">
                    {p.name}
                  </h3>
                  <p className="text-[#FFC72C] text-xs font-black uppercase mb-6 tracking-widest">
                    {p.institution}
                  </p>
                  <p className="text-slate-400 text-sm italic mb-6 leading-relaxed">
                    "{p.role}"
                  </p>
                  <p className="text-slate-300 text-sm leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {p.bio}
                  </p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

 

      {/* Participation Methods */}
      <section id="participar" className="py-32 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-24">
            <h2 className="text-sm font-black text-blue-600 tracking-[0.3em] uppercase mb-6">
              Formas de ser parte
            </h2>
            <p className="text-5xl font-bold text-[#002855]">
              Únete a Investiga XIV 2026
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-10">
            {/* Assistant */}
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white rounded-[2.5rem] p-12 border border-slate-200 shadow-sm flex flex-col group"
            >
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-[#002855] transition-colors">
                <Users className="w-8 h-8 text-blue-600 group-hover:text-white" />
              </div>
              <h3 className="text-3xl font-black mb-6 text-[#002855]">
                Asistente
              </h3>
              <p className="text-slate-600  flex-grow text-lg">
                Vive la experiencia académica completa y obtén tu certificado
                digital validado.
              </p>
              <p className="text-slate-600 flex-grow text-lg">
                Para obtener tu certificado deberás participar en
                al menos 3 de las cuatro sesiones.
              </p>
              <ul className="space-y-4 mb-12">
                {[
                  "Conferencias magistrales",
                  "Actividades complementarias",
               
                ].map((li, i) => (
                  <li
                    key={i}
                    className="flex items-center text-slate-700 font-medium"
                  >
                    <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 shrink-0" />{" "}
                    {li}
                  </li>
                ))}
              </ul>
              <motion.a
                href="https://eventos.utpl.edu.ec/registro-investiga"
                whileTap={{ scale: 0.95 }}
                className="w-full py-5  text-center rounded-2xl border-2 border-blue-600 text-blue-600 font-black hover:bg-blue-50 transition"
              >
                Registro Asistente
              </motion.a>
            </motion.div>

            {/* Oral Presentation */}
            <motion.div
              initial={{ scale: 1 }}
              whileHover={{ scale: 1.05, y: -10 }}
              className="bg-[#002855] rounded-[2.5rem] p-12 shadow-2xl flex flex-col text-white relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 p-8">
                <div className="bg-[#FFC72C] text-[#002855] text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-widest animate-pulse">
                  Convocatoria
                </div>
              </div>
              <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-8">
                <BookOpen className="w-8 h-8 text-[#FFC72C]" />
              </div>
              <h3 className="text-3xl font-black mb-6">Ponente Oral</h3>
              <p className="text-blue-100  flex-grow text-lg">
                Posiciona tu trabajo científico en un entorno de alto nivel y
                diálogo crítico.
              </p>
              <ul className="space-y-4 mb-12">
                {[
                  "Diálogo crítico de saberes",
                  "Networking institucional",
                  "Publicación en memorias",
                ].map((li, i) => (
                  <li
                    key={i}
                    className="flex items-center text-blue-200 font-medium"
                  >
                    <CheckCircle2 className="w-5 h-5 text-[#FFC72C] mr-3 shrink-0" />{" "}
                    {li}
                  </li>
                ))}
              </ul>

              <motion.a
                href="https://sica.utpl.edu.ec/"
                whileTap={{ scale: 0.95 }}
                className="w-full py-5 text-center text-white rounded-2xl bg-[#FFC72C] font-black hover:bg-yellow-400 hover:text-[#004270] transition shadow-xl"
              >
                Postular Resumen
              </motion.a>

              <p className="text-xs pt-8">
                Si no estás registrado en la plataforma, deberás crear una
                cuenta de usuario.
              </p>
              <a
                className="text-xs underline"
                href="https://sica.utpl.edu.ec/register"
              >
                Crear un usuario
              </a>
            </motion.div>

            {/* Poster Presenter */}
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white rounded-[2.5rem] p-12 border border-slate-200 shadow-sm flex flex-col group"
            >
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-[#002855] transition-colors">
                <FileText className="w-8 h-8 text-blue-600 group-hover:text-white" />
              </div>
              <h3 className="text-3xl font-black mb-6 text-[#002855]">
                Póster Científico
              </h3>
              <p className="text-slate-600 mb-10 flex-grow text-lg">
                Formato dinámico para compartir avances investigativos e
                interactuar con pares.
              </p>
              <ul className="space-y-4 mb-12">
                {[
                  "Formato visual interactivo",
                  "Evaluación de comité",
                  "Reconocimiento por mesa",
                ].map((li, i) => (
                  <li
                    key={i}
                    className="flex items-center text-slate-700 font-medium"
                  >
                    <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 shrink-0" />{" "}
                    {li}
                  </li>
                ))}
              </ul>
              <motion.a
                href="https://sica.utpl.edu.ec/"
                whileTap={{ scale: 0.95 }}
                className="w-full py-5 rounded-2xl border-2 text-center border-blue-600 text-blue-600 font-black hover:bg-blue-50 transition"
              >
                Postular Póster
              </motion.a>
              <p className="text-xs pt-8 text-slate-600">
                Si no estás registrado en la plataforma, deberás crear una
                cuenta de usuario.
              </p>
              <a
                className="text-xs underline text-slate-600"
                href="https://sica.utpl.edu.ec/register"
              >
                Crear un usuario
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Scientific Committee */}
      <section className="py-32 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-end mb-20">
            <div>
              <h2 className="text-sm font-black text-blue-600 tracking-widest uppercase mb-4">
                Excelencia Académica
              </h2>
              <p className="text-5xl font-bold text-[#002855]">
                Comité Científico
              </p>
            </div>
          </div>

          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6"
          >
            {comite.map((m, i) => (
              <motion.div
                key={i}
                variants={fadeInUp}
                whileHover={{ scale: 1.02 }}
                className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:shadow-lg transition-all group"
              >
                <p className="font-black text-[#002855] group-hover:text-blue-600 transition-colors">
                  {m.name}
                </p>
                <p className="text-xs text-slate-500 mt-2 italic font-medium leading-relaxed">
                  {m.dept}
                </p>
                <div className="mt-4">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={m.url}
                    className="inline-flex items-center gap-1 text-[#004270] text-xs font-semibold uppercase tracking-wider opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 hover:text-[#0066a3]"
                  >
                    Ver perfil
                    <ChevronRight
                      size={14}
                      className="transition-transform duration-300 group-hover:translate-x-1"
                    />
                  </a>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

           {/* Stats - Infographic */}
      <section className="py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-24 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              {" "}
              <h2 className="text-sm font-black text-blue-600 tracking-widest uppercase mb-4">
                Ediciones Anteriores
              </h2>
              <h2 className="text-4xl font-black text-[#002855] mb-8 leading-tight">
                Un legado de investigación que trasciende fronteras
              </h2>
              <p className="text-xl text-slate-600 mb-10 leading-relaxed">
                Investiga se consolida como un nodo de conocimiento colectivo,
                promoviendo soluciones sostenibles frente a los grandes desafíos
                del desarrollo.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-2xl bg-green-50 flex items-center justify-center shrink-0">
                    <CheckCircle2 className="text-green-500" />
                  </div>
                  <div>
                    <h5 className="font-black text-[#002855]">
                      Memorias con ISBN
                    </h5>
                    <p className="text-sm text-slate-500">
                      15 volúmenes publicados de alto rigor.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-2xl bg-blue-50 flex items-center justify-center shrink-0">
                    <CheckCircle2 className="text-blue-500" />
                  </div>
                  <div>
                    <h5 className="font-black text-[#002855]">
                      Instituciones Aliadas
                    </h5>
                    <p className="text-sm text-slate-500">
                      Red de 90+ organizaciones globales.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              className="grid grid-cols-2 gap-8"
            >
              {estadisticas.map((stat, idx) => (
                <motion.div
                  key={idx}
                  variants={fadeInUp}
                  className="bg-[#004270] p-10 rounded-[2.5rem] border-b-8 border-blue-100 flex flex-col justify-center items-center text-center hover:bg-[#002855] hover:text-white hover:border-[#FFC72C] transition-all duration-300"
                >
                  <p className="text-5xl font-black mb-2">{stat.value}</p>
                  <p className="text-sm font-black uppercase tracking-tighter mb-1">
                    {stat.label}
                  </p>
                  <p className="text-xs opacity-60 font-medium">{stat.sub}</p>
                </motion.div>
              ))}
            </motion.div>
          </div>

          <ul className="space-y-3 mt-10">
            <li>
              <a
                href="https://utpl.edu.ec/investiga/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#004270] hover:text-[#0066a3] transition-colors duration-200 font-medium"
              >
                <FileText size={18} />
                Investiga XIII
              </a>
            </li>

            <li>
              <a
                href="https://utpl.edu.ec/investiga/investiga-12"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#004270] hover:text-[#0066a3] transition-colors duration-200 font-medium"
              >
                <FileText size={18} />
                Investiga XII
              </a>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default Informacion;
